// extracted by mini-css-extract-plugin
module.exports = {"footerModalBtn":"gtmConfiguration_footerModalBtn__1zw_5","webSitesLabel":"gtmConfiguration_webSitesLabel__d3pnH"};